import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from './src/ui/__generated__/ListQuery$parameters';

export const listEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-list", jiraSpaEntry: "async-servicedesk-list" */ './src/ui/List.tsx'
			),
	),
	getPreloadProps: ({ context: { match }, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const boardId = match.params.boardId;
		const boardAri = `ari:cloud:jira-software:${cloudId}:board/${boardId}`;
		const projectKey = match.params.projectKey ?? '';

		const issueSearchInput = {
			customInput: {
				jiraSoftwareInput: {
					jiraEntityId: boardAri,
					additionalJql: '',
				},
			},
		};

		const fieldSetsInput = fg('jsm_list_minor_bug_fixes_and_analytic_event')
			? {
					viewInput: {
						namespace: 'JSM_ISSUE_NAVIGATOR',
						viewId: 'list_default',
						filterId: null,
					},
				}
			: {
					viewInput: {
						namespace: 'JSM_ISSUE_NAVIGATOR',
						filterId: null,
					},
				};

		const defaultProps = {
			first: 50,
			last: null,
			before: null,
			after: null,
			options: { issueKey: null },
			viewConfigInput: {
				staticViewInput: {
					isHierarchyEnabled: false,
					isGroupingEnabled: false,
					isHideDoneEnabled: false,
				},
			},
			filterId: null,
			namespace: 'JSM_ISSUE_NAVIGATOR',
			amountOfColumns: 500,
			groupBy: null,
			viewQueryInput: null,
			shouldQueryHasChildren: false,
			fieldSetsInput,
			scope: {
				operationScope: 'NIN_PROJECT' as const,
				projectKey,
			},
			fieldSetsScope: {
				operationScope: 'NIN_PROJECT' as const,
				projectKey,
			},
			boardId: boardAri,
			viewId: 'list_default',
		};

		return {
			queries: {
				jsmListDataQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						issueSearchInput,
						projectKey,
						...defaultProps,
					},
				},
			},
			extraProps: {
				cloudId,
				projectKey,
				issueSearchInput,
				defaultProps,
			},
		};
	},
});
